module.exports = __webpack_public_path__ + "img/footer-logo-desktop.65847404.png";